export default __webpack_public_path__ + "static/media/arrow-right.47a1e3dc.svg";